<template>
  <v-slide-x-transition>
    <v-list-tile v-if="classification" class="pt-2">
      <v-autocomplete
        v-model="model"
        @keyup.ctrl.enter="createFeatureFromInput"
        autofocus
        clearable
        dense
        hide-details
        item-text="name"
        item-value="id"
        :items="features"
        label="Atributo"
        :loading="loadingFeatures"
        :no-data-text="noDataText"
        open-on-clear
        prepend-icon="list"
        :search-input.sync="input"
      >
        <template #item="{ item }">
          <span>{{ item.name }}</span>
          <v-spacer />
          <v-confirmation-dialog
            @confirm="removeFeatureAndClear(item.id)"
            :text="confirmationText(item)"
          >
            <template #activator="{ on }">
              <v-btn v-on="on" class="ma-0" icon>
                <v-icon color="grey">clear</v-icon>
              </v-btn>
            </template>
          </v-confirmation-dialog>
        </template>
      </v-autocomplete>
    </v-list-tile>
  </v-slide-x-transition>
</template>

<script>
import { mapActions, mapState } from "vuex";
import VConfirmationDialog from "@/components/confirmations/ConfirmationDialog.vue";

export default {
  components: {
    VConfirmationDialog
  },
  data: () => ({
    input: null
  }),
  computed: {
    ...mapState("featureRules", [
      "classification",
      "feature",
      "features",
      "loadingFeatures"
    ]),
    model: {
      get() {
        return this.feature;
      },
      set(id) {
        this.setFeature(id);
      }
    },
    /**
     * Show the message that indicates that the user could create a new feature.
     */
    noDataText() {
      if (this.input) {
        return `Presiona ctrl + enter para crear el atributo "${this.input}"`;
      } else if (this.loadingFeatures) {
        return `Cargando atributos ...`;
      } else {
        return `No hay atributos, intenta crear el primero!`;
      }
    }
  },
  methods: {
    ...mapActions("featureRules", [
      "createFeature",
      "getFeatures",
      "removeFeature",
      "setFeature"
    ]),
    /**
     * Generate the confirmation text for the given feature.
     */
    confirmationText(feature) {
      return `
      ¿Estás seguro que quieres eliminar el atributo '${feature.name}'?
      Esto borarrá el atributo, TODAS sus reglas y TODOS los atributos creados. 
      `;
    },
    /**
     * Create a new feature and set it as selected.
     */
    async createFeatureFromInput() {
      const feature = await this.createFeature(this.input);
      this.setFeature(feature.id);
    },
    /**
     * Remove a feature and clear the input.
     */
    async removeFeatureAndClear(id) {
      await this.removeFeature(id);
      this.model = null;
    }
  }
};
</script>